import logo from './logo.svg';
 import Weather from './weather-folder/App';

function App() {

 // const url=`https://api.openweathermap.org/data/2.5/weather?lat=122.09&lon=37.39&appid={}`

  return (
    <div className="App">
       <Weather/>
    </div>
  );
}

export default App;
